import React from 'react';
import SMOSpaceEditBaseFragment from './SMOSpaceEditBaseFragment';
import SMConst from 'lib/SMConst';
import SMFormFieldTitle from 'components/dashboard/form/SMFormFieldTitle';
import SMFormTextFieldWithError from 'components/dashboard/form/SMFormTextFieldWithError';
import SMFormTextAreaWithError from 'components/dashboard/form/SMFormTextAreaWithError';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import SMOSpaceMapView from '../SMOSpaceMapView';
import SMOAcademyLinkBaloonView from 'components/dashboard/owners/SMOAcademyLinkBaloonView';

class SMOSpaceEditAddressFragment extends SMOSpaceEditBaseFragment {

  constructor(props) {
    super(props);
    this.state = {
      space: this.props.space,
      areas: this.props.areas,
      isCurrent : this.isCurrent(this.props),
      errors: this.props.errors,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
      space : nextProps.space,
      areas : nextProps.areas,
    });
  }

  render() {
    let items = [];
    for (var i = 0; i < this.state.areas.length; i++) {
      const area = this.state.areas[i];
      items.push({value: area.name, label: area.name_text});
    }
    const mapDisplay = this.state.isCurrent ? SMConst.Display.Visible : SMConst.Display.Hidden;

    return (
      <div ref="fragment" style={this.fragmentStyle()}>
        <SMFormFieldTitle title={I18n.t('dashboard.label_000176')} subTitle={I18n.t('dashboard.text_000035')} isRequired={true} />
        <SMFormTextFieldWithError
          name="postal_code"
          value={this.state.space.postal_code}
          errorText={SMFormatHelper.errorText('Space', 'postal_code', this.props.errors)}
          placeholderText="1600023"
          options={{className:"w110"}}
          delegate={this}
        />

        <SMFormFieldTitle title={I18n.t('dashboard.label_000177')} isRequired={true} />
        <div className="form-box">
          <span className="form-select__inner mr5">
            <label className="form-select">
              <SMFormSelectBox name="state" items={items} selectedValue={this.state.space.state} delegate={this} />
            </label>
          </span>
          <SMFormTextField name="city" value={this.state.space.city} placeholderText="新宿区" options={{className:"w300"}} delegate={this} />
          <SMFormValidationMessage name='city' errorText={SMFormatHelper.errorText('Space', 'city', this.props.errors)} />
        </div>

        <SMFormFieldTitle title={I18n.t('dashboard.label_000178')} isRequired={true} />
        <SMFormTextFieldWithError
          name="address_1"
          value={this.state.space.address_1}
          errorText={SMFormatHelper.errorText('Space', 'address_1', this.props.errors)}
          placeholderText="西新宿6-15-1"
          delegate={this}
        />

        <SMFormFieldTitle title={I18n.t('dashboard.label_000179')} isRequired={false} />
        <SMFormTextFieldWithError
          name="address_2"
          value={this.state.space.address_2}
          errorText={SMFormatHelper.errorText('Space', 'address_2', this.props.errors)}
          placeholderText="ラ・トゥール新宿608号室"
          options={{className:'w600'}}
          delegate={this}
        />

        <SMFormFieldTitle title={I18n.t('dashboard.label_000096')} isRequired={true} subTitle={I18n.t('dashboard.text_000051')} />

        <SMFormTextFieldWithError
          name="tel"
          value={this.state.space.tel}
          type="tel"
          errorText={SMFormatHelper.errorText('Space', 'tel', this.props.errors)}
          placeholderText="03-1234-5678"
          options={{className:'w600'}}
          delegate={this}
        />

        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>FAX番号
        </h2>
        <SMFormTextFieldWithError
          name="fax"
          value={this.state.space.fax}
          type="tel"
          errorText={SMFormatHelper.errorText('Space', 'fax', this.props.errors)}
          placeholderText="03-1234-5678"
          options={{className:'w600'}}
          delegate={this}
        />

        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__required">必須</span>アクセス
          <span className="dashboard-title__supplement ml15">
            最寄駅からの歩き方や高速道路の出口、所要時間などを入力してください。
          </span>
        </h2>
        <SMFormTextAreaWithError
          name="access"
          value={this.state.space.access}
          errorText={SMFormatHelper.errorText('Space', 'access', this.props.errors)}
          placeholderText="JR新宿駅西口より徒歩7分"
          delegate={this}
        />

        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__optional">任意</span>地図の設定
          <span className="dashboard-title__supplement ml15">
            ドラッグ＆ドロップでピンの位置を変更できます。
          </span>
        </h2>
        <SMOSpaceMapView space={this.state.space} name="has_map_view" display={mapDisplay} delegate={this} />

        <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
          <a href="#" className="button button-green maincol-buttonarea__button" onClick={this.didSelectNextFragment.bind(this)}>次へ</a>
        </div>

        <SMOAcademyLinkBaloonView displayPlace={SMConst.AcademyLinkDisplayPlace.SpaceAddress} isCurrent={this.state.isCurrent} />
      </div>
    );
  }
}

SMOSpaceEditAddressFragment.defaultProps = {
  errors: [],
};

export default SMOSpaceEditAddressFragment;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/spaces/fragments/SMOSpaceEditAddressFragment.jsx